import { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { CardFooter } from "react-bootstrap";
import { otherActivityDeleteFile, otherActivityDeleteRecord, otherActivityDetail, otherActivityEdit, otherActivityGetFile, otherActivityPostFile } from "../../config/apiSPA.js";
import { useNavigate, useParams } from "react-router-dom";
import DateFormat from "../../components/dateFormater/dateFormat1.js";
import ModalUploadFile2 from "../../components/modal/modalUploadFile2.jsx";
import ModalEditSelect2 from "../../components/modal/modalEditSelect2.jsx";
import ModalEditDate2 from "../../components/modal/modalEditDate2.jsx";
import ModalEditTextArea from "../../components/modal/modalEditTextArea.jsx";
import ModalConfirm from "../../components/modal/modalConfirm.jsx";
import ModalLoading from "../../components/modal/modalLoading.jsx";
import ModalInfo from "../../components/modal/modalInfo.jsx";

const initialdataList = {
  id: null,
  instructors_id: null,
  activity_id: null,
  date: "",
  remark: "",
  activity_name: "",
  activity_sub_name: "",
  instructor: "",
  updater: "",
  evident: [],
};
const optionsActivityName = {
  title: "Edit Activity Name",
  text: "Please select availabe activity name",
};
const optionsActivityInstructor = {
  title: "Edit Instructor",
  text: "Please select availabe Instructor",
};
const optionsActivityRemark = {
  title: "Edit remark",
  text: "Please edit remark. default : -",
};
function OtherActivityDetail() {
  const [dataList, setDataList] = useState(initialdataList);
  const [loadingData, setLoadingData] = useState(true);
  const [modalUploadEvident, setModalUploadEvident] = useState({ status: false, id: null });
  const [modalEditActivityTitle, setModalEditActivityTitle] = useState({ show: false, options: {}, selector: "", id: null });
  const [modalEditActivityInstructor, setModalEditActivityInstructor] = useState({ show: false, options: {}, selector: "", id: null });
  const [modalEditDate, setModalEditDate] = useState({ show: false, id: null, currentDate: "" });
  const [modalEditRemark, setModalEditRemark] = useState({ show: false, id: null, currentValue: "", options: {} });
  const [modalDeleteConfirm, setModalDeleConfirm] = useState({ show: false, id: null, text: "" });
  const [modalDeleteReportConfirm, setModalDeleteReportConfirm] = useState({ show: false, id: null, text: "" });
  const [modalUploadFile, setModalUploadFile] = useState({ show: false, progress: 0 });
  const [modalInfo, setModalInfo] = useState({ show: false, theme: "", title: "", text: "" });
  const navigate = useNavigate();
  const { id } = useParams();
  const handleClickAddFile = () => {
    setModalUploadEvident({ status: true, id: id });
  };
  const handleSubmitFile = async (e) => {
    setModalUploadEvident({ status: false, id: null });
    setModalUploadFile({ show: true, progress: 0 });
    e.append("id", id);
    try {
      const res = await otherActivityPostFile(e, (e) => setModalUploadFile((a) => ({ ...a, progress: e })));
      setModalUploadFile((a) => ({ ...a, show: false }));
      setDataList(res.data);
    } catch (error) {
      setModalUploadFile((a) => ({ ...a, show: false }));
      setModalInfo({ show: true, theme: "danger", title: "Failed", text: `Gagal upload file : ${error.message}` });
    }
  };
  const handleClickActivityName = () => {
    setModalEditActivityTitle({ show: true, options: optionsActivityName, id: id, selector: "activity-other-list" });
  };
  const handleSubmitEditActivityName = async (val) => {
    setModalEditActivityTitle((a) => ({ ...a, show: false }));
    try {
      const res = await otherActivityEdit("/edit-activity", { id: val.id, activityId: val.val });
      setDataList(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleClickActivityInstructor = () => {
    setModalEditActivityInstructor({ show: true, options: optionsActivityInstructor, id: id, selector: "instructor" });
  };
  const handleSubmitEditActivityInstructor = async (val) => {
    setModalEditActivityInstructor((a) => ({ ...a, show: false }));
    try {
      const res = await otherActivityEdit("/edit-instructor", { id: val.id, instructorId: val.val });
      setDataList(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleClickActivityDate = (date) => {
    setModalEditDate({ show: true, id: id, currentDate: date });
  };
  const handleSubmitEditActivityDate = async (val) => {
    setModalEditDate((a) => ({ ...a, show: false }));
    try {
      const res = await otherActivityEdit("/edit-date", { id: val.id, date: val.val });
      setDataList(res.data);
    } catch (error) {
      setModalInfo({ show: true, theme: "danger", title: "Failed", text: `Error message : ${error.message}` });
    }
  };
  const handleClickActivityRemark = (val) => {
    setModalEditRemark({ show: true, id: id, currentValue: val, options: optionsActivityRemark });
  };
  const handleSubmitEditActivityRemark = async (val) => {
    setModalEditRemark((a) => ({ ...a, show: false }));
    try {
      const res = await otherActivityEdit("/edit-remark", { id: val.id, remark: val.val });
      setDataList(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const handleClickDeleteFile = (id) => {
    setModalDeleConfirm({ show: true, id: id, text: "Are you sure want to delete this file ?" });
  };
  const handleConfirmClickDeleFile = async (idFile) => {
    setModalDeleConfirm((a) => ({ ...a, show: false }));
    try {
      await otherActivityDeleteFile(idFile);
      const res = await otherActivityDetail(id);
      setDataList(res.data);
    } catch (error) {}
  };
  const handleDownloadFile = (idFile, fileName) => {
    otherActivityGetFile(idFile);
  };
  const handleDeleteActivityReport = () => {
    setModalDeleteReportConfirm({ show: true, id: id, text: "Are you sure want to delete this activity ?" });
  };
  const handleConfirmClickDeleteReport = (val) => {
    setModalDeleteReportConfirm((a) => ({ ...a, show: false }));
    otherActivityDeleteRecord(val)
      .then((res) => navigate(`/other-activity/data`))
      .catch((err) => setModalInfo({ show: true, theme: "danger", title: "Failed", text: `Gagal menghapus report, message: ${err.message}` }));
  };

  useEffect(() => {
    otherActivityDetail(id)
      .then((res) => {
        setDataList(res.data);
        setLoadingData(false);
      })
      .catch((err) => setLoadingData(true));
  }, []);
  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="row">
              <div className="col-xl-9">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#/">Other Activity</a>
                  </li>
                  <li className="breadcrumb-item active">Detail</li>
                </ul>

                <h1 className="page-header">Other Activity Detail</h1>

                <hr className="mb-4" />

                <div id="formControls" className="mb-5">
                  <div>
                    <p>
                      <strong>Other Activities</strong> refer to professional contributions that are not categorized as formal training or mentoring sessions. These activities focus on supporting continuous improvement, knowledge
                      development, quality enhancement, and operational excellence within the organization.
                    </p>
                  </div>
                  <Card>
                    <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Other Activity Detail</CardHeader>
                    <CardBody>
                      {loadingData ? (
                        <p>Loading.....</p>
                      ) : (
                        <>
                          <div className="list-group list-group-flush">
                            <div className="list-group-item d-flex align-items-center">
                              <div className="flex-1 text-break">
                                <div className="text-theme">Activity Name</div>
                                <div className="text-inverse text-opacity-50">{dataList.activity_name}</div>
                              </div>
                              <div className="w-50px text-center">
                                <a href="#/" onClick={handleClickActivityName} className="btn btn-outline-default btn-sm">
                                  <i className="fas fa-edit text-theme"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="list-group list-group-flush">
                            <div className="list-group-item d-flex align-items-center">
                              <div className="flex-1 text-break">
                                <div className="text-theme">Instructor</div>
                                <div className="text-inverse text-opacity-50">{dataList.instructor}</div>
                              </div>
                              <div className="w-50px text-center">
                                <a href="#/" onClick={handleClickActivityInstructor} className="btn btn-outline-default btn-sm">
                                  <i className="fas fa-edit text-theme"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="list-group list-group-flush">
                            <div className="list-group-item d-flex align-items-center">
                              <div className="flex-1 text-break">
                                <div className="text-theme">Date</div>
                                <div className="text-inverse text-opacity-50">{DateFormat(dataList.date)}</div>
                              </div>
                              <div className="w-50px text-center">
                                <a href="#/" onClick={() => handleClickActivityDate(dataList.date)} className="btn btn-outline-default btn-sm">
                                  <i className="fas fa-edit text-theme"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="list-group list-group-flush">
                            <div className="list-group-item d-flex align-items-center">
                              <div className="flex-1 text-break">
                                <div className="text-theme">Remark </div>
                                <div className="text-inverse text-opacity-50">{dataList.remark}</div>
                              </div>
                              <div className="w-50px text-center">
                                <a href="#/" onClick={() => handleClickActivityRemark(dataList.remark)} className="btn btn-outline-default btn-sm">
                                  <i className="fas fa-edit text-theme"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </CardBody>
                  </Card>
                  <Card className="mb-4">
                    <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Evident</CardHeader>
                    {loadingData ? (
                      <CardBody>
                        <p>Loading.....</p>
                      </CardBody>
                    ) : (
                      <>
                        <CardBody className="card-body pb-2">
                          <div className="mb-2">
                            <div className="d-block d-lg-flex align-items-center">
                              <span onClick={handleClickAddFile} className="btn btn-outline-theme me-2 mb-1">
                                <i className="fa fa-fw fa-plus"></i>
                                <span>Add files...</span>
                              </span>
                            </div>
                          </div>
                        </CardBody>

                        {dataList.evident.length < 1 ? (
                          <div className="alert alert-danger mx-3">Evident activity anda masih kosong, segera upload evident activity anda contoh: screeshoot hasil upload document, absensi dll.</div>
                        ) : (
                          <div className="table-responsive">
                            <table className="table table-card mb-0 fs-13px">
                              <thead>
                                <tr className="fs-12px">
                                  <th className="pt-2 pb-2 w-25">FILENAME</th>
                                  <th className="pt-2 pb-2 w-25">SIZE</th>
                                  <th className="pt-2 pb-2 w-25">UPLOADED</th>
                                  <th className="pt-2 pb-2 w-25">ACTION</th>
                                </tr>
                              </thead>
                              <tbody className="files">
                                {dataList.evident.map((val) => (
                                  <tr key={val.id}>
                                    <td className="align-middle">{val.fileName}</td>
                                    <td className="align-middle">{val.size}</td>
                                    <td className="align-middle">{DateFormat(val.created_at)}</td>
                                    <td>
                                      <a href="#/" onClick={() => handleClickDeleteFile(val.id)} className="btn btn-outline-default btn-sm">
                                        <i className="fas fa-trash-alt text-danger"></i>
                                      </a>
                                      <a href="#/" onClick={() => handleDownloadFile(val.id, val.fileName)} className="btn btn-outline-default btn-sm">
                                        <i className="fas fa-download text-theme"></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </>
                    )}
                  </Card>
                  <a href="#/" onClick={handleDeleteActivityReport} className="text-danger">
                    Delete
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalUploadFile2 show={modalUploadEvident.status} onHide={() => setModalUploadEvident((a) => ({ ...a, status: false }))} submitClick={handleSubmitFile} />
      <ModalEditSelect2
        show={modalEditActivityTitle.show}
        onHide={() => setModalEditActivityTitle((a) => ({ ...a, show: false }))}
        selector={modalEditActivityTitle.selector}
        id={modalEditActivityTitle.id}
        options={modalEditActivityTitle.options}
        submitClick={handleSubmitEditActivityName}
      />
      <ModalEditSelect2
        show={modalEditActivityInstructor.show}
        onHide={() => setModalEditActivityInstructor((a) => ({ ...a, show: false }))}
        selector={modalEditActivityInstructor.selector}
        id={modalEditActivityInstructor.id}
        options={modalEditActivityInstructor.options}
        submitClick={handleSubmitEditActivityInstructor}
      />
      <ModalEditDate2 show={modalEditDate.show} id={modalEditDate.id} currentDate={modalEditDate.currentDate} onHide={() => setModalEditDate((a) => ({ ...a, show: false }))} submitClick={handleSubmitEditActivityDate} />
      <ModalEditTextArea show={modalEditRemark.show} id={modalEditRemark.id} onHide={() => setModalEditRemark((a) => ({ ...a, show: false }))} currentValue={modalEditRemark.currentValue} submitClick={handleSubmitEditActivityRemark} />
      <ModalConfirm
        show={modalDeleteConfirm.show}
        id={modalDeleteConfirm.id}
        clicked={handleConfirmClickDeleFile}
        onHide={() => setModalDeleConfirm((a) => ({ ...a, show: false }))}
        title={"WARNING....!"}
        theme={"danger"}
        text={modalDeleteConfirm.text}
      />
      <ModalConfirm
        show={modalDeleteReportConfirm.show}
        id={modalDeleteReportConfirm.id}
        clicked={handleConfirmClickDeleteReport}
        onHide={() => setModalDeleteReportConfirm((a) => ({ ...a, show: false }))}
        title={"WARNING....!"}
        theme={"danger"}
        text={modalDeleteReportConfirm.text}
      />
      <ModalLoading show={modalUploadFile.show} value={modalUploadFile.progress} title={"Uploading..."} text={"Your file is currently uploading. Please do not close this window. wait"} />
      <ModalInfo show={modalInfo.show} theme={modalInfo.theme} clicked={() => setModalInfo((a) => ({ ...a, show: false }))} onHide={() => setModalInfo((a) => ({ ...a, show: false }))} title={modalInfo.title} text={modalInfo.text} />
    </>
  );
}

export default OtherActivityDetail;
